import * as React from 'react';
import { cn } from '@utils';

type BoundingBoxProps = {
	padding?: React.CSSProperties['padding'];
	width?: React.CSSProperties['width'];
	height?: React.CSSProperties['height'];
	orientation?: 'horizontal' | 'vertical';
};

export const BoundingBox: React.FC<BoundingBoxProps> = ({
	padding = '0 40px',
	width,
	height,
	orientation = 'vertical',
	children,
}) => {
	return (
		<div
			className={cn('flex items-center justify-center', orientation ? 'flex-col' : 'flex-row')}
			style={{ padding, width: width ?? '100%', height: height ?? '100%' }}
		>
			{children}
		</div>
	);
};
